<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h1 class="cf-title cf-title--1">
      This menu is currently unavailable.
    </h1>

    <p class="cf-subtitle cf-subtitle--2">
      Please feel free to browse our menu to get some ideas for later.
    </p>

    <button
      class="cf-button cf-button--primary cf-button--lg"
      type="button"
      @click="browseMenuHandler"
    >
      Browse Menu
    </button>
  </div>
</template>


<script>
  export default {
    name: 'MenuUnavailable',

    methods: {
      browseMenuHandler() {
        this.$closeModal('menu-unavailable-modal');

        this.$router.push({ name: 'orderMenu', params: { merchantId: this.$route.params.merchantId } });
      }
    }
  };
</script>
